import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Compbaser} from "../../../../components/compbaser";
import {StoreSelectorsService} from "../../../../services";
import {actionUpdateSceneItem} from "../../../../store/actions/user.actions";
import {Id, ISceneBlock, ISceneTreeSliceResults} from "../../../../interfaces";
import * as _ from 'lodash';

/**
 * The Collection "touch" sibling accordion (rendered by scene-editor next to Collection/layout/events for
 * Collection blocks). Holds the interactivity controls - keyboard navigation, idle-revert, and the
 * mouse-interrupt (attract) behavior - self-contained: it reads the currently-selected Collection from the
 * store and dispatches attribute writes to Data[0].Collection[0].$, mirroring block-layout-common-props.
 */
@Component({
    selector: 'app-block-collection-touch',
    templateUrl: './block-collection-touch.component.html',
    styleUrls: ['./block-collection-touch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BlockCollectionTouchComponent extends Compbaser implements OnInit {
    private sceneId: Id;
    private sceneItem: ISceneBlock;

    useHotkeys = false;
    onIdle = false;
    idleDuration = '10';
    mouseInterrupt = false;
    mouseInterruptPage = '';

    constructor(private storeSelector: StoreSelectorsService, private cd: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.listenPlayerDataOfSelectedSceneItemId()
                .subscribe((slice: ISceneTreeSliceResults) => {
                    if (!slice || !slice.sceneItem) return;
                    this.sceneId = slice.sceneId;
                    this.sceneItem = slice.sceneItem;
                    this.sync();
                    this.cd.markForCheck();
                })
        );
    }

    /** Live list of page names for the interrupt-target picker. */
    get collectionPages(): Array<{ page: string }> {
        const pages = this.sceneItem?.Data?.[0]?.Collection?.[0]?.Page;
        return (pages && _.isArray(pages)) ? pages.map((p) => ({page: p?.$?.page})) : [];
    }

    private sync() {
        const $ = this.sceneItem?.Data?.[0]?.Collection?.[0]?.$ || {} as any;
        this.useHotkeys = $.useHotkeys == '1';
        this.onIdle = $.onIdle == '1';
        this.idleDuration = $.idleDuration || '10';
        this.mouseInterrupt = $.mouseInterrupt == '1';
        this.mouseInterruptPage = $.mouseInterruptPage || '';
    }

    private write(key: string, value: string) {
        if (!this.sceneItem) return;
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{key, value, storePath: 'Data[0].Collection[0].$'}]
        }));
        this.storeSelector.dispatch({type: 'BREAK_MERGE'});
    }

    toggleUseHotkeys() { this.write('useHotkeys', this.useHotkeys ? '1' : '0'); }
    toggleOnIdle() { this.write('onIdle', this.onIdle ? '1' : '0'); }
    changeIdleDuration() { this.write('idleDuration', `${this.idleDuration}`); }
    toggleMouseInterrupt() { this.write('mouseInterrupt', this.mouseInterrupt ? '1' : '0'); }
    changeMouseInterruptPage() { this.write('mouseInterruptPage', `${this.mouseInterruptPage || ''}`); }
}
